import { useHookstate } from '@hookstate/core'
import { Typography } from 'antd'
import qs from 'qs'
import { useContext, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import rootStoreContext from '../../../../store.context'
import { doMutation } from '../../../../utils/gqlClient'
import Loading from '../../../components/loading'

export const MarketingOptOut = () => {
	const { search } = useLocation()

	const state = useHookstate({
		email: null as string | null,
		loading: true,
		success: true
	})

	const rootStore = useContext(rootStoreContext)

	const getEmail = () => {
		const { email } = qs.parse(search.replace(`?`, ``))
		if (!email) return
		state.email.set(email as string)
	}

	const postOptOut = async () => {
		if (rootStore.laboratory._id?.trim().length === 0) return

		const email = state.email.get()
		if (!email) return

		const { success } = await doMutation(`
			success: laboratory_emailMarketingOptOut_public(email: "${email}")
		`)

		state.loading.set(false)
		state.success.set(!!success)
	}

	useEffect(() => { getEmail() }, []) // eslint-disable-line

	useEffect(() => { postOptOut() }, [rootStore.laboratory, state.email]) // eslint-disable-line

	return (
		<div
			className={`d-flex justify-content-center align-items-center`}
			style={{
				width: `100dwh`,
				height: `100dvh`,
			}}
		>
			{
				state.loading.get()
					? <Loading show={true} />
					: <>
						{
							state.success.get()
								? <Typography.Title className={`text-center`}>
									{`E-mail descadastrado com sucesso!`}
								</Typography.Title>
								: <Typography.Title className={`text-center`}>
									{`Erro ao descadastrar seu e-mail. Tente novamente...`}
								</Typography.Title>
						}
					</>
			}
		</div >
	)
}